import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AppService {
allowedPermissions : any[] = []
  constructor() {
    this.allowedPermissions = JSON.parse(localStorage.getItem("Permissions"))
   }
  dateToString = (date) => {

    if (!date)
      return '';

    return `${date.year}-${date.month}-${date.day}`;
  };
  dateToStringsingledigit = (date) => {
    var dateval = {
      day: date.day < 10 ? '0' + date.day : date.day,
      month: date.month < 10 ? '0' + date.month : date.month,
      year: date.year
    }
    if (!date)
      return '';
    return `${dateval.year}-${dateval.month}-${dateval.day}`;
  };
  datetongbdate = (date) => {
    var ngbdate = {
      day:Number(moment(date,'YYYY-MM-DD').format('DD')),
      month:Number(moment(date,'YYYY-MM-DD').format('MM')),
      year:Number(moment(date,'YYYY-MM-DD').format('YYYY'))
    }
    if(!date){return ''}else{ return ngbdate}
  };

  changevaluetodata(value,arr){
    if(value == null){
      return null;
    }
    let val = typeof(value) == 'boolean' ? (value == true ? "1" : "0") : value
    
   let finaltxt = arr.find(x=>x.value == val)
   if(finaltxt){
    return finaltxt.text
   }else{
    return null
   }
   
  }

  patternValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$');
      const valid = regex.test(control.value);
      return valid ? null : { invalidPassword: true };
    };
  }
  ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}
validateAllFormFields(formGroup: FormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof FormGroup) {

      this.validateAllFormFields(control);
    }
  });
}
checkpermission(code){
    let ispermission = this.allowedPermissions.find(x=>x.Permissions == code)
    if(ispermission){
    return true
    }else{
    return false
    }
    
}
 async getFileFromUrl(url, name, defaultType = 'image/jpeg') {
    if (!url)
      return "";
    try {
      if (name == '') {
        var fullname = url.split('/').pop();
        name = fullname.split('-').pop();
      }
      const response = await fetch(url);
      const data = await response.blob();
      return new File([data], name, {
        type: response.headers.get('content-type') || defaultType,
      });
    } catch (error) {
      return "";
    }

  }
}
